/* eslint-disable react/jsx-props-no-spreading */
import { faDiagramPredecessor, faTableList, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { faGripDotsVertical } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { inMarketTheme } from '@inmarket/inmarkit';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Stack, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';

import { Section as SectionType } from '../../validationSchemas/ReportTemplateSchema';

export interface SectionItemProps {
  section: SectionType;
  index?: number;
  onEdit?: Function;
  onRemove?: Function;
  listeners?: any;
}

function SectionItem({ section, index, onEdit, onRemove, listeners }: SectionItemProps) {
  const [isHovered, setHovered] = useState(false);
  const [isDeleteHovered, setDeleteHovered] = useState(false);

  return (
    <Stack
      key={section.sectionName}
      direction="row"
      py={2}
      px={1}
      spacing={1}
      justifyContent="space-between"
      onMouseOver={() => setHovered(true)}
      onMouseOut={() => setHovered(false)}
      onClick={() => onEdit && onEdit(section, index)}
      sx={{ cursor: 'pointer' }}
      aria-label={`Edit Section ${section.sectionName}`}
    >
      <Stack direction="row" spacing={1}>
        <Stack {...listeners} alignSelf="center" width="16px">
          <FontAwesomeIcon
            icon={faGripDotsVertical}
            style={{ cursor: 'grab', display: !isHovered && 'none' }}
            color="action"
          />
        </Stack>
        <Stack>
          <Typography>{section.sectionName}</Typography>
          <Typography variant="caption" color="grey">
            {section.sectionType} | {section.columns.length} columns
          </Typography>
        </Stack>
      </Stack>
      <Stack direction="row">
        <Stack direction="row" sx={{ display: !isHovered && 'none' }} spacing={1} pt={1}>
          <Tooltip title={`Partition by IO: ${section.partitionByIo ? 'Yes' : 'No'}`}>
            <FontAwesomeIcon
              icon={faTableList}
              color={section.partitionByIo ? inMarketTheme.palette.primary.main : '#8C8C8C'}
            />
          </Tooltip>
          <Tooltip title={`Include Subtotals: ${section.partitionByIo ? 'Yes' : 'No'}`}>
            <FontAwesomeIcon
              icon={faDiagramPredecessor}
              color={section.includeSubtotals ? inMarketTheme.palette.primary.main : '#8C8C8C'}
            />
          </Tooltip>
          <Tooltip title="Delete Section">
            <FontAwesomeIcon
              icon={faTrash}
              style={{ cursor: 'pointer' }}
              onClick={(e) => {
                e.stopPropagation();
                if (onRemove) {
                  onRemove(section.sectionName);
                }
              }}
              aria-label={`Delete Section ${section.sectionName}`}
              color={isDeleteHovered ? inMarketTheme.palette.error.main : '#8C8C8C'}
              onMouseOver={() => setDeleteHovered(true)}
              onMouseOut={() => setDeleteHovered(false)}
            />
          </Tooltip>
        </Stack>
        <NavigateNextIcon color="action" />
      </Stack>
    </Stack>
  );
}

export default SectionItem;
